import {memo} from 'react';
import styles from './PageSubheading.module.scss';

export const PageSubHeading = memo(({text}: {text: string}) => {
  return <h3 className={styles.subheading}>{text}</h3>;
});
PageSubHeading.displayName = 'PageSubHeading';
